import withSSRModel from "hoc-lib/ssrModelMapper"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { FacilityListItem as FacilityListItemComponent } from "./FacilityListItem"

export const mapDispatchToProps = (dispatch) => ({
  reduxActions: bindActionCreators(
    {
      // fetchWmUsNav,
    },
    dispatch,
  ),
})

export const mapStateToProps = (state) => ({
  siteLanguage: state.siteLanguage,
  facilityAlerts: state.facilityLocator.alerts,
})

const WrappedComponent = withSSRModel(
  connect(mapStateToProps, mapDispatchToProps)(FacilityListItemComponent),
)

// Component has to be mapped by the consumer
// Config has to be imported from constants-lib and passed to the MapTo function by the consumer
export default WrappedComponent
